import { FC, ReactNode } from "react";
import { Drawer as MantineDrawer, DrawerProps as MantineDrawerProps } from "@mantine/core";
import styles from "./styles.module.css";

type DrawerProps = Partial<MantineDrawerProps> & {
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  children: ReactNode;
};

const Drawer: FC<DrawerProps> = ({ children, isOpen, onClose, ...drawerProps }) => {
  return (
    <MantineDrawer
      opened={isOpen}
      onClose={onClose}
      position="right"
      size="lg"
      classNames={{
        header: styles.header,
        body: styles.body,
        content: styles.content,
      }}
      {...drawerProps}
    >
      {children}
    </MantineDrawer>
  );
};

export default Drawer;
